import { CSSProperties } from "react";
import { ThemeOptions } from "@mui/material";

import { MuiButtonBase } from "./components/MuiButtonBase";
import { MuiTooltip } from "./components/MuiTooltip";
import { MuiRadio } from "./components/MuiRadio";
import { MuiButton } from "./components/MuiButton";
import { MuiCard } from "./components/MuiCard";
import { MuiCardContent } from "./components/MuiCardContent";
import { MuiTabs } from "./components/MuiTabs";
import { MuiTab } from "./components/MuiTab";
import { MuiChip } from "./components/MuiChip";
import { MuiStepContent } from "./components/MuiStepContent";
import { MuiStepConnector } from "./components/MuiStepConnector";
import { MuiStepLabel } from "./components/MuiStepLabel";
import { MuiDivider } from "./components/MuiDivider";
import { MuiSkeleton } from "./components/MuiSkeleton";
import { MuiDialog } from "./components/MuiDialog";
import { MuiDialogContent } from "./components/MuiDialogContent";
import { MuiDialogTitle } from "./components/MuiDialogTitle";
import { MuiSvgIcon } from "./components/MuiSvgIcon";
import { MuiTextField } from "./components/MuiTextField";
import { MuiSelect } from "./components/MuiSelect";
import { MuiFormLabel } from "./components/MuiFormLabel";
import { MuiTableCell } from "./components/MuiTableCell";
import { MuiTableRow } from "./components/MuiTableRow";
import { MuiInputAdornment } from "./components/MuiInputAdornment";
import { MuiDrawer } from "./components/MuiDrawer";
import { MuiAlert } from "./components/MuiAlert";
import { MuiMenu } from "./components/MuiMenu";
import { MuiMenuItem } from "./components/MuiMenuItem";
import { MuiInputLabel } from "./components/MuiInputLabel";
import { MuiCheckbox } from "./components/MuiCheckbox";
import { MuiSwitch } from "./components/MuiSwitch";
import { MuiFormControl } from "./components/MuiFormControl";
import { MuiFilledInput } from "./components/MuiFilledInput";
import { MuiOutlinedInput } from "./components/MuiOutlinedInput";
import { MuiSlider } from "./components/MuiSlider";
import { MuiTable } from "./components/MuiTable";
import { MuiAutocomplete } from "./components/MuiAutocomplete";
import { MuiCssBaseline } from "./components/MuiCssBaseline";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    caption1: CSSProperties;
    caption2: CSSProperties;
    sectionLabel: CSSProperties;
    title: CSSProperties;
    text: CSSProperties;
  }
  interface TypographyVariantsOptions {
    caption1?: CSSProperties;
    caption2?: CSSProperties;
    sectionLabel?: CSSProperties;
    title?: CSSProperties;
    text?: CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    caption1: true;
    caption2: true;
    sectionLabel: true;
    title: true;
    text: true;
  }
}

const spacing = 8;

const themeConfig: ThemeOptions = {
  typography: {
    fontFamily: "Inter",
    fontSize: 14,
    allVariants: {
      color: "#000000",
    },
    h1: {
      fontWeight: 700,
      fontSize: 60,
      lineHeight: "70px",
      letterSpacing: "0.25px",
    },
    h2: {
      fontWeight: 400,
      fontSize: 48,
      lineHeight: "70px",
      letterSpacing: "0.25px",
    },
    subtitle1: {
      fontWeight: 500,
      fontSize: 20,
      lineHeight: "120%",
      letterSpacing: "0.02em",
    },
    subtitle2: {
      fontWeight: 700,
      fontSize: 16,
      lineHeight: "120%",
      letterSpacing: "0.02em",
    },
    body1: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: "140%",
    },
    caption1: {
      fontWeight: 500,
      fontSize: 12,
      lineHeight: "100%",
    },
    caption2: {
      fontWeight: 500,
      fontSize: 10,
      lineHeight: "100%",
    },
    sectionLabel: {
      fontWeight: 500,
      fontSize: 14,
      lineHeight: "100%",
      letterSpacing: "-0.05px",
    },
    title: {
      fontWeight: 700,
      fontSize: 36,
      lineHeight: "120%",
    },
    text: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: "140%",
      color: "#616161",
    },
  },
  spacing,
  breakpoints: {},
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiFormControl,
    MuiButtonBase,
    MuiTooltip,
    MuiRadio,
    MuiButton,
    MuiCard,
    MuiCardContent,
    MuiCheckbox,
    MuiTabs,
    MuiTab,
    MuiChip,
    MuiStepContent,
    MuiStepConnector,
    MuiStepLabel,
    MuiDivider,
    MuiSkeleton,
    MuiDialog,
    MuiDialogContent,
    MuiDialogTitle,
    MuiSvgIcon,
    MuiTextField,
    MuiSelect,
    MuiFormLabel,
    MuiFilledInput,
    MuiOutlinedInput,
    MuiTable,
    MuiTableCell,
    MuiTableRow,
    MuiInputAdornment,
    MuiDrawer,
    MuiAlert,
    MuiMenu,
    MuiMenuItem,
    MuiInputLabel,
    MuiSwitch,
    MuiSlider,
    MuiAutocomplete,
    MuiCssBaseline
  },
};

export default themeConfig;
